import { render, staticRenderFns } from "./newstOrder.vue?vue&type=template&id=5a4c6c8c&scoped=true&"
import script from "./newstOrder.vue?vue&type=script&lang=js&"
export * from "./newstOrder.vue?vue&type=script&lang=js&"
import style0 from "./newstOrder.vue?vue&type=style&index=0&id=5a4c6c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c6c8c",
  null
  
)

export default component.exports